import { getDefaultAsyncWrapperObj, AsyncRequestStatus } from '@ane/core/lib/models';
export const defaultReducerState = {
    items: getDefaultAsyncWrapperObj(),
};
// Action Types
const actionTypesPrefix = 'loadDataSourceList';
export const dataSourceListActionTypes = {
    LOAD: `${actionTypesPrefix}/LOAD`,
    LOADING: `${actionTypesPrefix}/LOADING`,
    LOADED: `${actionTypesPrefix}/LOADOADED`,
};
// Action Creators
export const dataSourceListLoadAction = (workspaceId, search) => {
    return {
        type: dataSourceListActionTypes.LOAD,
        payload: { workspaceId: workspaceId, search: search },
    };
};
export const dataSourceListLoadingAction = (payload) => {
    return {
        type: dataSourceListActionTypes.LOADING,
        payload: payload,
    };
};
export const dataSourceListLoadedAction = (payload, result) => {
    return {
        type: dataSourceListActionTypes.LOADED,
        payload: {
            items: result,
        },
    };
};
// Reducer
export const reducer = (state = defaultReducerState, action) => {
    switch (action.type) {
        case dataSourceListActionTypes.LOADING:
            return {
                ...state,
                items: {
                    ...state.items,
                    status: AsyncRequestStatus.Pending,
                },
            };
        case dataSourceListActionTypes.LOADED:
            const loadedAction = action;
            return {
                ...state,
                items: loadedAction.payload.items,
            };
        default:
            return state;
    }
};
export default reducer;

//# sourceMappingURL=DataSourceList.ducks.js.map
